import React from 'react';
import { Link } from 'react-router-dom';
import whyUsData from './whyUsData';
import WhyUsItem from './WhyUsItem';

function WhyUs() {
  return (
    <section className="why-us-wrapper section-padding">
      <div className="container">
        <div className="row gy-6 gy-5 gy-lg-0">
          <div className="col-lg-6 d-flex align-items-center">
            <div className="left-content">
              <div className="section-head">
                <span className="heading-bg">Why us</span>
                <h2 className="section-title mb-30">
                  We are chosen by the best companies
                  <span className="heading-dot" />
                </h2>
              </div>
              <p className="body-text">
                Among our customers are famous people, athletes, businessmen.
                Our architects will help your family find the formula for an
                ideal country house that will be 100% consistent with your
                lifestyle, ideas about a comfortable country life, the concept
                of resource conservation.
              </p>
              <Link to="/" className="button button-primary mt-35">
                Learn More
              </Link>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="right-content">
              <div className="row">
                {whyUsData.map((data) => (
                  <WhyUsItem
                    key={data.id}
                    icon={data.icon}
                    heading={data.heading}
                    text={data.text}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
